import { format, parseISO } from "date-fns";

export const formatDate = (date: string, formatStr: string = 'yyyy-MM-dd') => {
  if (!date) return "";

  const parsedDate =
    typeof date === "string" ? parseISO(date) : date;

  return format(parsedDate, formatStr);
};

export const formatPatientAdminConsulationDate = (date: string) => {
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) return '';

  const day = dateObj.getUTCDate().toString().padStart(2, '0');
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const month = months[dateObj.getUTCMonth()];
  const year = dateObj.getUTCFullYear().toString();

  const hour = dateObj.getUTCHours().toString().padStart(2, '0');
  const mins = dateObj.getUTCMinutes().toString().padStart(2, '0');
  const secs = dateObj.getUTCSeconds().toString().padStart(2, '0');
  return `${year}-${month}-${day}, ${hour}:${mins}:${secs}`;
}